import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export function InstallPrompt() {
  const [prompt, setPrompt] = useState<Event | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!prompt) return null;

  return (
    <Button
      size="sm"
      variant="outline"
      className="gap-2"
      data-testid="install-app-button"
      onClick={async () => {
        const p = prompt as unknown as { prompt: () => Promise<void> };
        await p.prompt();
        setPrompt(null);
      }}
    >
      <Download className="h-4 w-4" />
      Install App
    </Button>
  );
}
